<app-detail-list-template [Inline]="true" [Editing]="Editing" *ngIf="templateData$ | async as data" [Data]="data"></app-detail-list-template>
